var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { xs: "12", "no-margin": "" } },
    [
      _c(
        "w-row",
        [
          _c("app-sale-search", {
            staticStyle: { "flex-grow": "1" },
            attrs: {
              value: _vm.value,
              fancy: _vm.fancy,
              label: _vm.label,
              placeholder: _vm.placeholder,
              disabled: _vm.disabled,
              "show-remove-button": _vm.showRemoveButton,
            },
            on: {
              input: function ($event) {
                return _vm.$emit("input", $event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-link",
                {
                  staticClass: "searchSale",
                  attrs: { disabled: _vm.disabled },
                  on: {
                    click: function ($event) {
                      return _vm.openBrowseModal()
                    },
                  },
                },
                [
                  _c("w-fa", { attrs: { icon: "search" } }),
                  _vm._v(" " + _vm._s(_vm.$ct("sale-search")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.browseModalOpen,
            callback: function ($$v) {
              _vm.browseModalOpen = $$v
            },
            expression: "browseModalOpen",
          },
        },
        [
          _vm.browseModalOpen
            ? _c(
                "w-card",
                { style: { maxWidth: "95%", top: "20px" } },
                [
                  _c(
                    "w-card-title",
                    { staticClass: "blue" },
                    [
                      _vm._v(" " + _vm._s(_vm.$ct("sale-search")) + " "),
                      _c("w-spacer"),
                      _c(
                        "w-link",
                        {
                          attrs: { white: "" },
                          on: {
                            click: function ($event) {
                              _vm.browseModalOpen = false
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "times" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { style: { height: "calc(100vh - 180px)" } },
                    [
                      _c("app-sale-browse", {
                        attrs: {
                          view: _vm.view,
                          "clear-view-settings-filters":
                            _vm.generalSettings.ClearF3SearchFilter,
                          multiple: _vm.multiple,
                          "override-static-view-select": true,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onBrowseItemSelected($event)
                          },
                          multiple: function ($event) {
                            return _vm.onBrowseItemsSelected($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }